import Alpine from 'alpinejs';

import { AppStore } from './app_store';

if (!Alpine.store('appStore')) {
    Alpine.store('appStore', new AppStore());
}

export const appStore = Alpine.store('appStore') as AppStore;
